import type { GetStaticProps } from 'next';

import { fetchBlogPosts, fetchCaseStudies } from '../../utils/api/fetchStrapiData';
import { formatFilterNameToValue } from '../../views/caseStudies/CaseStudies.utils';
import { RustWebAppDevelopmentPage } from '../../views/rustWebAppDevelopmentPage';

export const getStaticProps: GetStaticProps = async () => {
  const [blogPosts, allCaseStudies] = await Promise.all([fetchBlogPosts(), fetchCaseStudies()]);
  const caseStudies = allCaseStudies
    .filter((cs) =>
      cs.case_study_technologies.some(
        (tech) =>
          tech?.name &&
          formatFilterNameToValue(tech.name) === 'rust'
      )
    )
    .slice(0, 3);

  return {
    props: { blogPosts, caseStudies },
  };
};

export default RustWebAppDevelopmentPage;
